import React from 'react';
import './Backgroundhome.css';

const Backgroundhome = () => {
  return (
    <div className="homeback__container">
      <div className="homeback__bubbles">
        <span className="span1"></span>
        <span className="span2"></span>
        <span className="span3"></span>
        <span className="span4"></span>
        <span className="span5"></span>
        <span className="span6"></span>
        <span className="span7"></span>
        <span className="span8"></span>
        <span className="span9"></span>
        <span className="span10"></span>
      </div>
    </div>
  );
};

export default Backgroundhome;
